
// const CONFIG = {
//    chainId: 1, 
//    contractAddress: "0x5811636989856D80df369De9A103502df7377c03",
//    tokenAddress: "0x71E368Ed06814Bf35d4E663eFf946400a5BC8115", 
//    tokenDecimals: '18',
//    tokenSymbol: 'MDCY', 
//    networkName: 'Ethereum Mainnet'
// }

const CONFIG = {
    chainId: 1,
    contractAddress: "0xB290f756dd6a7e9111ea877e1A72Ba3001F6525d",
    tokenAddress: "0xFEead860FFa43e5660Ca62ea5953a74F695C1D5B", 
    tokenDecimals: '18',
    tokenSymbol: 'MDCY', 
    networkName: 'Ethereum Mainnet'
}

export default CONFIG;